import type { Training } from "@peer-start/platform-contracts";
import { Button, Card } from "@peer-start/ui";
import { BookOpenCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

export function TrainingContent({
  training,
  controlId,
  pending,
  onComplete,
}: {
  training: Training;
  controlId: string;
  pending?: boolean;
  onComplete?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Card>
      <BookOpenCheck aria-hidden="true" className="mb-4 size-10 text-primary" />
      <h2 className="text-xl font-medium">{training.title}</h2>
      <p className="mt-2 text-muted-foreground">
        {training.description} · {t("common.minutes", { count: training.minutes })}
      </p>
      <div className="mt-6 space-y-4">
        {training.sections.map((section, index) => (
          <article className="rounded-lg bg-card p-5" key={section.title}>
            <p className="mb-2 text-xs font-medium uppercase tracking-widest text-primary">{index + 1}</p>
            <h3 className="font-medium">{section.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{section.body}</p>
            {section.tip ? (
              <p className="mt-3 rounded-xl bg-warning p-3 text-sm font-medium text-warning-foreground">
                {t("skill.tip")}: {section.tip}
              </p>
            ) : null}
          </article>
        ))}
      </div>
      {onComplete ? (
        <Button className="mt-6" controlId={`${controlId}.complete`} disabled={pending} onClick={onComplete}>
          {t("skill.completeTraining")}
        </Button>
      ) : null}
    </Card>
  );
}
